import { Map } from "immutable";
function createImmutableMap(object) {
  return Map(object);
}
export {
  createImmutableMap as default
};
